import React from "react";
import PropTypes from "prop-types";
import Week from "react-big-calendar/lib/Week";
import TimeGrid from "react-big-calendar/lib/TimeGrid";

// This adapter follows the custom-view contract of react-big-calendar 0.22.
function createShortWeek(dayCount) {
  const range = (date, options) => Week.range(date, options).slice(0, dayCount);

  function ShortWeek({ date, ...props }) {
    return <TimeGrid {...props} range={range(date, props)} eventOffset={15} />;
  }

  ShortWeek.propTypes = { date: PropTypes.instanceOf(Date).isRequired };
  ShortWeek.defaultProps = TimeGrid.defaultProps;
  ShortWeek.range = range;
  ShortWeek.navigate = Week.navigate;
  ShortWeek.title = (date, { localizer }) => {
    const visibleDates = range(date, { localizer });
    return localizer.format({ start: visibleDates[0], end: visibleDates[dayCount - 1] }, "dayRangeHeaderFormat");
  };
  return ShortWeek;
}

export const FiveDayWeek = createShortWeek(5);
export const SixDayWeek = createShortWeek(6);
